import React, {useContext, useCallback, useState, useEffect, useMemo} from 'react'
import styled, {ThemeContext} from 'styled-components'
import { ButtonPrimary } from '../../../components/Button'
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import ModalActions from '../../../components/bakery/ModalActions'
import Input from '../../../components/bakery/Input'
import InsufficientModal from '../../../components/nftInfo/modal/InsufficientModal'

import SortPets, { OptionProps } from '../../Pet/components/SortPets'
import { Text } from 'rebass'
import { useActiveWeb3React } from '../../../hooks'
import { getVotesSummary } from '../../../service/bakery'
import useTokenBalance from '../../../hooks/bakery/useTokenBalance'
import { getSushiAddress } from '../../../sushi/utils'
import useYam from '../../../hooks/bakery/useYam'
import { getFullDisplayBalance, getBalanceNumber } from '../../../utils/bakery/formatBalance'
import useModal from '../../../hooks/bakery/useModal'
 

const ConfirmBtn = styled.div`
  width: 116px;
  margin: 0 auto;
  & > button {
    height: 32px;
    font-size: 14px;
  }
`
const Button = styled(ButtonPrimary)`
  font-family: Baloo Da;
  height: 48px;
  padding: 0;
`
const TopCard = styled.div`
  position: relative;
  top: 0;
  width: 100%;
  background-color: ${({theme}) => theme.bsBg10};
  margin-bottom: 30px;
  border-radius: 20px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.16);
  padding: 22px 0 16px;
`
const TipsText = styled.div`
  width: 368px;
  padding: 0 20px;
  margin: 15px auto 23px;
  display: flex;
  justify-content: center;
`
const StyledTokenAdornmentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: ${({theme}) => theme.bsText3};
  & > div{
    width: 47px;
    & > button{
      height: 26px;
      border-radius: 5px;
    }
  }
`
const StyledTokenSymbol = styled.span`
  font-weight: 700;
`
const StyledInput = styled.div`
  width: 368px;
  margin: 0 auto;
  & > div {
    height: 48px;
    margin: 0 0 0px;
    background-color: ${({theme}) => theme.bsBg20};
    & > input {
      font-family: Baloo Da;
    }
  }
`
const BiddingList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 32px;
`
const BiddingItem = styled.li`
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.bg3};
`
const Amount = styled.div`
  display: flex;
  align-items: center;
  font-family: 'Baloo Da';
  & > div > span {
    color: ${({theme}) => theme.bsText7};
  }
`
const CardTitle = styled.div`
  font-size: 20px;
  color: ${({theme}) => theme.text1};
  margin: 32px 0;
  font-family: 'Baloo Da';
  text-align: center;
`
const ListMain = styled.div`
  position: relative;
  padding-top: 20px;
`
const SortBar = styled.div`
  width: 80px;
  position: absolute;
  right: 30px;
  top: -10px;
`
const StyledMaxText = styled.div`
  width: 368px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: ${({theme}) => theme.bsText7};
  font-size: 12px;
  font-weight: 600;
  margin: 0 auto;
  margin-top: 5px;
  margin-bottom: 16px;
`
interface BiddingModalProps extends ModalProps {
  onConfirm: (amount: string) => void
  tokenId: string
  type?: string
  nftType?: number
  nftId?: string
  name?: string
}

const options: OptionProps[] = [{
  sortName: 'votes',
  sortBy: 'asc',
  key: 1,
  name: 'Votes',
}, {
  sortName: 'votes',
  sortBy: 'desc',
  key: 2,
  name: 'Votes',
}]

function dealToken (address: any) {
  if (address) {
    return address.substring(0, 13) + '***********' + address.substring(25, 42)
  }
  return '-'
}
function compareAsc(p:any){ //这是比较函数
  return function(m:any,n:any){
      var a = m[p];
      var b = n[p];
      return a - b; //升序
  }
}
function compareDesc(p:any){ //这是比较函数
  return function(m:any,n:any){
      var a = m[p];
      var b = n[p];
      return b - a; //降序
  }
}

const WithdrawModal: React.FC<BiddingModalProps> = ({
  onConfirm,
  onDismiss,
  tokenId,
  type,
  nftType,
  nftId,
  name
}) => {
  const theme = useContext(ThemeContext)
  const sushi = useYam()
  const [val, setVal] = useState('')
  const emptyBids: any[] = []
  const [bids, setBids] = useState(emptyBids)
  const [pendingTx, setPendingTx] = useState(false)
  const [curSelect, setCurSelect] = useState(options[1])
  const { chainId } = useActiveWeb3React()
  const [list, setList] = useState([])
  const [tokenBalance, setTokenBalance] = useState(0)
  const bakeryBalance = useTokenBalance(getSushiAddress(sushi))
  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(bakeryBalance)
  }, [bakeryBalance])

  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    setTokenBalance(balance)
  }, [bakeryBalance])

  const [openInsufficientModal] = useModal(
    <InsufficientModal />
  )

  useEffect(() => {
    let params = {
      nftType: nftType,
      nftId: nftId
    }
    getVotesSummary(chainId as number, params, (err: any, d: any) => {
      if (err) return
      if (d.code !== 0) return
      setList(d.data.list)
    })
  }, [chainId, nftId, nftType])

  useEffect(() => {
    const test = list
    const bidList = [...test]
    if (curSelect.key === 2) {
      bidList.sort(compareDesc("votes"))
    } else {
      bidList.sort(compareAsc("votes"))
    }
    setBids(bidList)
  }, [curSelect, list])

  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])

  const orderBid = useCallback(async () => {
    try {
      if (+tokenBalance < +val) {
        openInsufficientModal()
        return
      }
      const realPrice = val
      setPendingTx(true)
      await onConfirm(realPrice)
      setPendingTx(false)
      onDismiss && onDismiss()
    } catch (e) {
      console.log(e)
    }
  }, [onConfirm, onDismiss, val, tokenBalance, openInsufficientModal])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const num: string = e.currentTarget.value.replace(/^0+/g, '').replace(/[^\d]/g, '')
      setVal(num)
    },
    [setVal]
  )
  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])

  return (
    <Modal maxWidth={598} backgroundColor={theme.bsBg1} padding={'0px 0 20px 0'}>
      {
        <TopCard>
          <Text color={theme.text1} fontSize={20} fontFamily={'Baloo Da'} textAlign={'center'}>Voting</Text>
          <TipsText>
            <Text fontWeight={700} color={theme.bsText7} fontFamily={'Yuanti SC'}>{ name ? name : ''}</Text>
          </TipsText>
          <StyledInput>
            <Input
              endAdornment={(
                <StyledTokenAdornmentWrapper>
                  <div style={{marginRight:12, width: 47}}>
                    <Button onClick={handleSelectMax}>Max</Button>
                  </div>
                  <StyledTokenSymbol>BAKE</StyledTokenSymbol>
                </StyledTokenAdornmentWrapper>
              )}
              onChange={handleChange}
              placeholder="0"
              value={val}
            />
          </StyledInput>
          <StyledMaxText>
            <Text color={theme.bsText3}>Balance：</Text>
            {fullBalance.toLocaleString()} BAKE
          </StyledMaxText>
          <ConfirmBtn>
            <Button
              disabled={pendingTx || (+val < 1)}
              onClick={orderBid}
              >
              vote
            </Button>
          </ConfirmBtn>
        </TopCard>
      }
      <ListMain>
        {
          bids.length > 0 && <SortBar>
            <SortPets
              curSelect={curSelect}
              options={options}
              updateData={updateData}
              height={30}
              top="40px"
            ></SortPets>
          </SortBar>
        }
        <BiddingList>
          {
            bids.length ? (
              bids.map((d) => {
                return (
                  <BiddingItem key={d.voter}>
                    <Text fontFamily={'Yuanti SC'} fontWeight={600} color={theme.bsText3}>{dealToken(d.voter)}</Text>
                    <Amount>
                      <img src="/images/bakery/icon_bake.svg" width={19} height={19} style={{marginRight: '5px'}} alt=""/>
                      { d.votes }
                      {/* <Value value={d.price}></Value> */}
                    </Amount>
                  </BiddingItem>
                )
              })
            ): (
              <CardTitle>No one has voted yet</CardTitle>
            )
          }
        </BiddingList>
      </ListMain>
      <ModalActions>
        
      </ModalActions>
    </Modal>
  )
}

export default WithdrawModal
